export const EXECUTION = 'execution';
export const CORRECTION = 'correction';
export const SOLUTION = 'solution';
